export const ADD_TRAINING = "ADD_TRAINING";
export const ADD_TRAINING_SUCCESS = "ADD_TRAINING_SUCCESS";
export const ADD_TRAINING_FAIL = "ADD_TRAINING_FAIL";

export const GET_TRAININGS_LIST = "GET_TRAININGS_LIST";
export const GET_TRAININGS_LIST_SUCCESS = "GET_TRAININGS_LIST_SUCCESS";
export const GET_TRAININGS_LIST_FAIL = "GET_TRAININGS_LIST_FAIL";

export const DELETE_TRAINING_LINK = " DELETE_TRAINING_LINK";
export const DELETE_TRAINING_LINK_SUCCESS = " DELETE_TRAINING_LINK_SUCCESS";
export const DELETE_TRAINING_LINK_FAIL = "    DELETE_TRAINING_LINK_FAIL";

export const UPDATE_TRAINING_LINK = "UPDATE_TRAINING_LINK";
export const UPDATE_TRAINING_LINK_SUCCESS = "UPDATE_TRAINING_LINK_SUCCESS";
export const UPDATE_TRAINING_LINK_FAIL = "UPDATE_TRAINING_LINK_FAIL";

export const ASSIGN_TRAININGS = "ASSIGN_TRAININGS";
export const ASSIGN_TRAININGS_SUCCESS = "ASSIGN_TRAININGS_SUCCESS";
export const ASSIGN_TRAININGS_FAIL = "ASSIGN_TRAININGS_FAIL";
